import { Component, EventEmitter, OnInit } from '@angular/core';
import { AwsService } from 'src/app/services/service.index';

@Component({
  selector: 'app-ver-empresas',
  templateUrl: './ver-empresas.component.html',
  styleUrls: ['./empresas.component.css']
})
export class VerEmpresasComponent implements OnInit {

  currentPage = 1;
  itemsPerPage = 10;
  searchTerm = '';
  items = [];
  cols = [
    {field: 'business_name', header: 'Nombre'},
    {field: 'company_rate', header: 'Tasa'},
    {field: 'rfc', header: 'RFC'},
    {field: 'sector', header: 'Sector'},
    {field: 'subsector', header: 'Subsector'},
  ];
  filaSeleccionada: number;
  agregarEmpresa = false;
  editarEmpresa = false;
  showEE = false;
  actualizaEmpresaEmitter = new EventEmitter<Object>();

  constructor(private awsService: AwsService) { }

  ngOnInit(): void {
    this.awsService.getCompanyes().subscribe(resp => {
      this.items = resp;
    })

    this.editarEmpresa = true;
    this.agregarEmpresa = false;
  }

  get totalPages(): number {
    return Math.ceil(this.filteredData.length / this.itemsPerPage);
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }

  seleccionarFila(index: number, currentPage: number, itemsPerPage: number) {
    this.filaSeleccionada = index + (currentPage - 1) * itemsPerPage;
  }

  resetIndex() {
    this.currentPage = 1;
    this.filaSeleccionada = -1;
  }
  
  get dataToShow(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.filteredData.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get filteredData(): any[] {
    return this.items.filter(item =>
      item.business_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      item.rfc.toLowerCase().includes(this.searchTerm.toLowerCase()) 
    );
  }

  agregar() {
    this.agregarEmpresa = true;
  }

  desplegarEditarEmpresa() {
    this.editarEmpresa = !this.editarEmpresa;
    this.agregarEmpresa = false;
  }

  cierraregusr(event) {
    this.showEE = false;
    this.editarEmpresa = true;
    this.agregarEmpresa = false;
    this.ngOnInit();
  }

  editarEmpresaEmit(contid: any, nomcont: any) {
    this.showEE = true;
    this.editarEmpresa = false;
    this.agregarEmpresa = false;
    setTimeout(() => {
      this.actualizaEmpresaEmitter.emit({contid: contid, nomcont: nomcont});
    }, 100);   
  }
// 
}
